import React from 'react';
import { HowItWorksConnections } from '../components/HowItWorksConnections';
import { ArchitectureDiagram } from '../components/ArchitectureDiagram';
import { LivesInSlack } from '../components/LivesInSlack';
import { ComputerUse } from '../components/ComputerUse';
import { CapabilityGrid } from '../components/CapabilityGrid';
import { NarrativeSection } from '../components/NarrativeSection';
import { ToolComparison } from '../components/ToolComparison';
import { WallOfLove } from '../components/WallOfLove';
import { PricingSection } from '../components/PricingSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function HomeArchitecture() {
  return <>
      <HowItWorksConnections mode="hero" data-id="element-4628" />
      <ArchitectureDiagram data-id="element-4629" />
      <HowItWorksConnections mode="how" data-id="element-4630" />
      <LivesInSlack data-id="element-4631" />
      <ComputerUse data-id="element-4632" />
      <CapabilityGrid data-id="element-4633" />
      <NarrativeSection data-id="element-4634" />
      <ToolComparison data-id="element-4635" />
      <WallOfLove data-id="element-4636" />
      <PricingSection data-id="element-4637" />
      <ClosingCTA data-id="element-4638" />
    </>;
}